"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _icons = require("../../icons");

var _DialogContentMobile = _interopRequireDefault(require("./DialogContentMobile"));

var _DialogContentDesktop = _interopRequireDefault(require("./DialogContentDesktop"));

var _Chip = _interopRequireDefault(require("../Chip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Dialog = function Dialog(_ref) {
  var toggleDialog = _ref.toggleDialog,
      complsOpen = _ref.complsOpen,
      setComplsOpen = _ref.setComplsOpen,
      fromDate = _ref.fromDate,
      toDate = _ref.toDate,
      hoverDate = _ref.hoverDate,
      onSelectDate = _ref.onSelectDate,
      onHoverDate = _ref.onHoverDate,
      handleReset = _ref.handleReset,
      handleClickDateInput = _ref.handleClickDateInput,
      inputFocus = _ref.inputFocus,
      handleChangeDate = _ref.handleChangeDate,
      startDatePlaceholder = _ref.startDatePlaceholder,
      endDatePlaceholder = _ref.endDatePlaceholder,
      startWeekDay = _ref.startWeekDay,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      dateFormat = _ref.dateFormat,
      weekDayFormat = _ref.weekDayFormat,
      monthFormat = _ref.monthFormat,
      isSingle = _ref.isSingle,
      isMobile = _ref.isMobile,
      highlightToday = _ref.highlightToday,
      hideDialogHeader = _ref.hideDialogHeader,
      hideDialogFooter = _ref.hideDialogFooter,
      dateInputSeperator = _ref.dateInputSeperator,
      singleCalendar = _ref.singleCalendar,
      selectedChip = _ref.selectedChip,
      setSelectedChip = _ref.setSelectedChip,
      dateList = _ref.dateList,
      updateFromDate = _ref.updateFromDate,
      updateToDate = _ref.updateToDate,
      renderDateList = _ref.renderDateList,
      title = _ref.title,
      selectedInput = _ref.selectedInput,
      isOpen = _ref.isOpen,
      onCancel = _ref.onCancel;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hideAnimation = _useState2[0],
      setHideAnimation = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 1),
      dateChanged = _useState4[0];

  var containerRef = (0, _react.useRef)();

  function handleChips(chip) {
    updateFromDate((0, _dayjs.default)(new Date(Date.now() - chip * 24 * 60 * 60 * 1000)));
    updateToDate((0, _dayjs.default)(new Date(new Date().getTime()).setHours(0, 0, 0, 0)));
  }

  function handleCloseDialog() {
    setComplsOpen(false);
    onCancel();
  }

  (0, _react.useEffect)(function () {
    if (complsOpen && !hideAnimation) {
      setHideAnimation(true);
    }

    if (complsOpen) {
      setTimeout(function () {
        if (containerRef.current && containerRef.current.getElementById) {
          var startDateInput = containerRef.current.getElementById('start-date-input-button');
          var endDateInput = containerRef.current.getElementById('end-date-input-button');

          if (startDateInput) {
            startDateInput.focus();
          } else if (endDateInput) {
            endDateInput.focus();
          }
        }
      }, 50);
    }
  }, [complsOpen, hideAnimation]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('dialog-date-picker', {
      open: complsOpen,
      hide: !complsOpen && hideAnimation,
      single: singleCalendar && !isMobile
    }),
    style: isOpen ? {
      right: '0rem'
    } : {
      left: '-0.125rem'
    },
    ref: containerRef
  }, !hideDialogHeader && /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-header"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "btn-outline back-button",
    onClick: toggleDialog
  }, /*#__PURE__*/_react.default.createElement(_icons.ArrowBackIos, {
    color: "secondary"
  })), /*#__PURE__*/_react.default.createElement("h4", {
    style: {
      color: '#686868'
    }
  }, title), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "btn-outline reset-button",
    onClick: handleCloseDialog
  }, /*#__PURE__*/_react.default.createElement(_icons.Clear, {
    fontSize: "large"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-content"
  }, isMobile ? /*#__PURE__*/_react.default.createElement(_DialogContentMobile.default, {
    fromDate: fromDate,
    toDate: toDate,
    hoverDate: hoverDate,
    onSelectDate: onSelectDate,
    startWeekDay: startWeekDay,
    minDate: minDate,
    maxDate: maxDate,
    dateFormat: dateFormat,
    weekDayFormat: weekDayFormat,
    monthFormat: monthFormat,
    complsOpen: complsOpen,
    isSingle: isSingle,
    highlightToday: highlightToday
  }) : /*#__PURE__*/_react.default.createElement(_DialogContentDesktop.default, {
    fromDate: fromDate,
    toDate: toDate,
    hoverDate: hoverDate,
    onSelectDate: onSelectDate,
    onHoverDate: onHoverDate,
    startWeekDay: startWeekDay,
    minDate: minDate,
    maxDate: maxDate,
    dateFormat: dateFormat,
    weekDayFormat: weekDayFormat,
    monthFormat: monthFormat,
    isSingle: isSingle,
    complsOpen: complsOpen,
    dateChanged: dateChanged,
    highlightToday: highlightToday,
    singleCalendar: singleCalendar,
    selectedInput: selectedInput
  })), !hideDialogFooter && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderDateList && /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-chips"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: '.35rem .35rem',
      color: '#686868'
    }
  }, "Select Last:"), dateList.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "dialog-chips-child"
    }, /*#__PURE__*/_react.default.createElement(_Chip.default, {
      size: "small",
      label: item.label,
      clickable: true,
      color: selectedChip === item.value ? 'primary' : 'outlined',
      onClick: function onClick() {
        return handleChips(item.value);
      }
    }));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "dialog-footer"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "submit-button",
    onClick: toggleDialog,
    tabIndex: "0"
  }, "Save"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "cancel-button",
    onClick: handleCloseDialog,
    tabIndex: "0"
  }, "cancel"))));
};

Dialog.propTypes = {
  complsOpen: _propTypes.default.bool,
  setComplsOpen: _propTypes.default.func,
  inputFocus: _propTypes.default.string,
  fromDate: _propTypes.default.instanceOf(Date),
  toDate: _propTypes.default.instanceOf(Date),
  hoverDate: _propTypes.default.instanceOf(Date),
  toggleDialog: _propTypes.default.func,
  handleClickDateInput: _propTypes.default.func,
  onSelectDate: _propTypes.default.func,
  onHoverDate: _propTypes.default.func,
  handleReset: _propTypes.default.func,
  handleChangeDate: _propTypes.default.func,
  startDatePlaceholder: _propTypes.default.string,
  endDatePlaceholder: _propTypes.default.string,
  startWeekDay: _propTypes.default.string,
  minDate: _propTypes.default.instanceOf(Date),
  maxDate: _propTypes.default.instanceOf(Date),
  dateFormat: _propTypes.default.string,
  monthFormat: _propTypes.default.string,
  isSingle: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  highlightToday: _propTypes.default.bool,
  weekDayFormat: _propTypes.default.string,
  hideDialogHeader: _propTypes.default.bool,
  hideDialogFooter: _propTypes.default.bool,
  dateInputSeperator: _propTypes.default.node,
  singleCalendar: _propTypes.default.bool,
  updateFromDate: _propTypes.default.func,
  updateToDate: _propTypes.default.func,
  renderDateList: _propTypes.default.bool,
  selectedInput: _propTypes.default.string,
  isOpen: _propTypes.default.bool,
  onCancel: _propTypes.default.func
};
Dialog.defaultProps = {
  complsOpen: false,
  setComplsOpen: function setComplsOpen() {},
  inputFocus: null,
  fromDate: null,
  toDate: null,
  hoverDate: null,
  toggleDialog: function toggleDialog() {},
  handleClickDateInput: function handleClickDateInput() {},
  onSelectDate: function onSelectDate() {},
  onHoverDate: function onHoverDate() {},
  handleReset: function handleReset() {},
  handleChangeDate: function handleChangeDate() {},
  startDatePlaceholder: null,
  endDatePlaceholder: null,
  startWeekDay: null,
  minDate: null,
  maxDate: null,
  dateFormat: '',
  monthFormat: '',
  isSingle: false,
  isMobile: false,
  highlightToday: false,
  weekDayFormat: '',
  hideDialogHeader: false,
  hideDialogFooter: false,
  dateInputSeperator: null,
  updateFromDate: function updateFromDate() {},
  updateToDate: function updateToDate() {},
  renderDateList: false,
  selectedInput: '',
  isOpen: false,
  onCancel: function onCancel() {}
};
var _default = Dialog;
exports.default = _default;